<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <rect width="64" height="64" fill="none"/>
    <g>
      <g>
        <circle class="filled" cx="26.922" cy="20.138" r="10.092" fill="#304266"/>
        <path class="filled" d="M26.922,34.879A19.08,19.08,0,0,0,8.1,50.87a2.687,2.687,0,0,0,2.672,3.084H43.078a2.687,2.687,0,0,0,2.671-3.084A19.08,19.08,0,0,0,26.922,34.879Z" fill="#304266"/>
      </g>
      <path class="filled" d="M42.734,20.138V21.37A1.232,1.232,0,0,0,43.966,22.6h5.663L41.4,30.826a1.233,1.233,0,0,0,0,1.743l.871.871a1.233,1.233,0,0,0,1.743,0l8.225-8.225v5.663a1.231,1.231,0,0,0,1.232,1.232h1.232a1.232,1.232,0,0,0,1.232-1.232V20.138a1.232,1.232,0,0,0-1.232-1.232H43.966A1.231,1.231,0,0,0,42.734,20.138Z" fill="#304266"/>
    </g>
  </g>
</svg>
